import React from "react";
import {
  MimaButton,
  MimaText,
  Modal,
  MimaInput,
  MimaDropdown,
} from "../../components";
import { Formik } from "formik";
import { values } from "mobx";
import * as yup from "yup";

const UpdateTransactionStatus = ({
  onSubmit,
  closeModal,
  validationSchema,
  roles,
  loading,
}) => {
  return (
    <Modal closeModal={closeModal}>
      <Formik
        initialValues={{
          sessionId: "",
          status: "",
          vendor: "",
        }}
        validationSchema={yup.lazy((values) => validationSchema(values))}
        onSubmit={onSubmit}
      >
        {({
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          values,
          errors,
          touched,
        }) => (
          <>
            <MimaText variant="subtitleBold" mb={3}>
              Update Transaction Status
            </MimaText>
            <MimaInput
              name="sessionId"
              labelTitle="Session Id"
              type="text"
              placeholder="Enter Session Id"
              value={values.sessionId}
              onChange={handleChange("sessionId")}
              onBlur={handleBlur("sessionId")}
              error={errors.sessionId}
              touched={touched.sessionId}
            />

            <MimaDropdown
              labelTitle="Status"
              placeholder="Select status"
              name="status"
              data={[
                { key: "PAID", value: "PAID" },
                { key: "FAILED", value: "FAILED" },
              ]}
              value={values.status}
              id="status"
              onChange={(data) => {
                setFieldValue("status", data.key);
              }}
              error={errors.status}
              touched={touched.status}
            />

            {values.status === "PAID" && (
              <MimaDropdown
                placeholder="Select Vendor"
                name="vendor"
                labelTitle="Vendor"
                value={values.vendor}
                currentValue={values.vendor}
                onBlur={handleBlur("vendor")}
                onChange={(data) => {
                  setFieldValue("vendor", data.key);
                }}
                data={[
                  { key: "PAYSTACK", value: "PAYSTACK" },
                  { key: "MONNIFY", value: "MONNIFY" },
                ]}
                error={errors.vendor}
                touched={touched.vendor}
              />
            )}
            <MimaButton
              title="Continue"
              onClick={() => {
                handleSubmit();
              }}
              width={38}
              loading={loading}
            />
          </>
        )}
      </Formik>
    </Modal>
  );
};

export default UpdateTransactionStatus;
